import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import { ECOM_FETCH_COUPONS, ECOM_INDEX_COUPONS, ECOM_VALIDATE_COUPONS } from '@/configs/ecom/apis';

export type CouponRequest = {
  phone: string;
  products: Product[];
  orderAmount: number;
};

export type Product = {
  productId: string;
  quantity: number;
};

export const fetchCoupons = async (body?: CouponRequest): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_FETCH_COUPONS), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const applyCoupon = async (body?: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_INDEX_COUPONS), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const validateCoupon = async (body?: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_VALIDATE_COUPONS), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
